export default __webpack_public_path__ + "static/media/logo.e4295569.svg";